// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2kpVf","overflowing":"ReadFullNote_overflowing__xdnDT"};